import { apiDELETE, apiGET, apiPOST } from '../utils/adapterFunctions'

export const getDepositPaymentProviders = async () => {
  return await apiGET('/payment-providers/deposit')
}

export const prevalidateWithdrawal = async () => {
  return await apiGET('/payments/withdrawal/prevalidate')
}

export const cancelWithdrawals = async (ids) => {
  return await apiDELETE('/payments/pending-withdrawals', {
    data: { transaction_ids: ids },
  })
}

export const getDepositCapabilites = async () => {
  return await apiGET('/capabilities/deposit')
}

export const getPaymentDepositLobby = async () => {
  return await apiGET('/lobbies/deposit')
}

export const getPaymentWithdrawalLobby = async () => {
  return await apiGET('/lobbies/withdrawal')
}

export const getLivenessStatus = async (onboardingId) => {
  return await apiGET(`/liveness/${onboardingId}`)
}

export const requestBankAccountWithdraw = async (body) => {
  return await apiPOST('/payments/v2/withdrawal/pix', body)
}

export const requestDepositV2 = async ({ endpoint, body }) => {
  return await apiPOST(endpoint, body)
}

export const requestDepositStatusV2 = async ({
  endpoint,
  transactionReference,
}) => {
  const params = { reference: transactionReference }
  return await apiGET(endpoint, { params })
}

export const requestLivenessPixPing = async () => {
  return await apiPOST('/ping-pay/liveness')
}

export const createPixPingBankAccount = async (body) => {
  return await apiPOST('/ping-pay', body)
}

export const getPlayerDepositOptions = async () => {
  return await apiGET('/payments/player/deposit-options/')
}